import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import "./services/i18n";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material";
import { theme } from "@sequentech/ui-essentials";
import AuthContextProvider from "./providers/AuthContextProvider";
import { SettingsContext, SettingsWrapper } from "./providers/SettingsContextProvider";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { WasmWrapper } from "./providers/WasmWrapper";
import { TenantEventContext } from "./providers/TenantEventContext";
export { TenantEventContext, TenantEventProvider } from "./providers/TenantEventContext";
var root = ReactDOM.createRoot(document.getElementById("root"));
var KeycloakProvider = function (_a) {
    var disable = _a.disable, children = _a.children;
    var _b = useContext(TenantEventContext), tenantId = _b.tenantId, eventId = _b.eventId;
    console.log("KeycloakProvider: tenantId=".concat(tenantId, ", eventId=").concat(eventId));
    return disable ? (_jsx(_Fragment, { children: children })) : (_jsx(AuthContextProvider, { children: _jsx(_Fragment, { children: children }) }));
};
export var KeycloakProviderContainer = function (_a) {
    var children = _a.children;
    var globalSettings = useContext(SettingsContext).globalSettings;
    return _jsx(KeycloakProvider, { disable: globalSettings.DISABLE_AUTH, children: children });
};
root.render(_jsx(React.StrictMode, { children: _jsx(WasmWrapper, { children: _jsx(SettingsWrapper, { children: _jsx(KeycloakProviderContainer, { children: _jsx(Provider, { store: store, children: _jsx(BrowserRouter, { children: _jsx(ThemeProvider, { theme: theme, children: _jsx(App, {}) }) }) }) }) }) }) }));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
